export class IAdminUserModel {
    public name: string;
    public role: string;
    public id: string;
}

export class AdminUsersResponse extends Array<IAdminUserModel> {}
